import React from 'react';
import { Menubar } from 'primereact/menubar';
import logo from '../../assets/logo.png';

const HomeMenu = ({ onSelectOption }) => {
  const items = [
    {
      label: 'Fornecedores',
      icon: 'pi pi-briefcase',
      command: () => onSelectOption('fornecedores')
    },
    {
      label: 'Clientes',
      icon: 'pi pi-users',
      command: () => onSelectOption('clientes')
    },
    {
      label: 'Movimentos',
      icon: 'pi pi-exchange',
      command: () => onSelectOption('movimentos')
    },
    {
      label: 'Familias',
      icon: 'pi pi-tags',
      command: () => onSelectOption('familias')
    },
    {
      label: 'Artigos',
      icon: 'pi pi-box',
      command: () => onSelectOption('artigos')
    },
    {
      label: 'Analises',
      icon: 'pi pi-chart-line',
      command: () => onSelectOption('analises')
    },
  ];

  // Elemento inicial (start) para o Menubar
  const start = (
    <div>
      <img src={logo} alt="Logo" style={{ height: '50px' }} />
    </div>
  );

  return (
    <div style={{ margin: '1rem 0' }}>
      <Menubar model={items} start={start} />
    </div>
  );
};

export default HomeMenu;
